function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.83 28.96V11.326l-6.576 5.458-.461.043-4.039.38c-.065.006-.12.068-.12.165v5.544c0 .083.069.16.113.165l4.507.423.356.296 6.22 5.162zm-7.178-13.627l7.205-5.98c.59-.489 1.473-.054 1.473.706v20.166c0 .761-.884 1.197-1.473.707l-7.205-5.979-4.045-.38c-.83-.082-1.473-.815-1.473-1.658V17.37c0-.87.642-1.577 1.473-1.658l4.045-.38zm12.535 2.25a.75.75 0 011.34-.674c.11.22.264.594.415 1.097.6 2 .6 4.157-.411 6.221a.75.75 0 11-1.347-.66c.822-1.678.822-3.462.321-5.13a5.76 5.76 0 00-.318-.855zm3.16-3.033a.75.75 0 011.26-.814c.253.393.619 1.085.98 2.018 1.447 3.734 1.447 7.743-.98 11.503a.75.75 0 11-1.26-.814c2.13-3.3 2.13-6.821.842-10.147-.189-.486-.39-.923-.59-1.303a6.56 6.56 0 00-.253-.443z",
  fill: "#000",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40"
  }, props), _ref);
};

export default SvgComponent;